import { useAppSelector } from "../../../hooks/store-hooks";

import ProfileImageComp from "../../common/profile";
import { conversionOfPostDate } from "../../../helpers";
import BecomeMemberButton from "../../common/membership/BecomeMemberButton";
import { Channel } from "stream-chat";
import { useState, useEffect } from "react";

const GroupChat = ({
  handleWhenSelectDataAndOpenLeftPanel = () => null,
}: any) => {
  const { homeData } = useAppSelector((state) => state.home || {});
  const userData = homeData?.user || {};
  const { isOpcMember } = useAppSelector((state: any) => state.home);

  const { allTeamChannelWithoutJoin, allChattedChannel } = useAppSelector(
    (state) => state.chat || {},
  );

  const [lastMsgs, setlastMsgs] = useState<any[]>([]);

  useEffect(() => {
    setlastMsgs(
      allChattedChannel.map((channel: Channel) => {
        return channel.state.messages[channel.state.messages.length - 1];
      }),
    );
  }, [allChattedChannel]);

  const renderJoinedChannelList = () => {
    const height = allChattedChannel.length * 90;
    return (
      <div
        className="flex flex-col divide-y divide-gray-200"
        style={{ height: `${height}px` }}
      >
        {allChattedChannel
          .filter(
            (item: any) => item?.type === "team" || item?.type === "adminOnly",
          )
          .map((item: any, index: number) => {
            const details = item?.data;
            const last_msg = lastMsgs[index];
            const channelType = item?.type;
            return (
              <div
                key={index}
                className="flex items-center justify-between px-4 py-3 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  handleWhenSelectDataAndOpenLeftPanel({
                    user: { ...item.data },
                    type: channelType,
                  });
                }}
              >
                <div className="flex items-center justify-start w-full">
                  <div className="w-10 relative">
                    <ProfileImageComp
                      imageUrl={details?.image || ""}
                      customClass="w-10 h-10 rounded-full"
                      is_opc={details?.is_opc}
                    />
                    {details?.online ? (
                      <div className="w-2 h-2 rounded-full bg-[#01754f] absolute right-1 bottom-0"></div>
                    ) : null}
                  </div>
                  <div className="ml-3 flex flex-col justify-start flex-grow">
                    <h4 className="text-sm font-semibold text-gray-800 flex items-center">
                      {details?.name}
                    </h4>
                    <p className="text-xs text-neutral-700 truncate max-w-52">
                      {(last_msg &&
                        last_msg?.user?.name + ": " + last_msg?.text) ||
                        ""}
                    </p>
                  </div>
                  <div className="flex flex-col justify-between items-end gap-1">
                    <p className="text-xs text-neutral-700">
                      {conversionOfPostDate(last_msg?.created_at)}
                    </p>
                    <div>
                      {item?.state?.unreadCount > 0 && (
                        <div className="w-4 h-4 rounded-full text-xs text-white bg-[#FF271B] flex justify-center items-center ">
                          {item.state.unreadCount}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  const renderChannelList = () => {
    return (
      <div className="flex overflow-x-scroll space-x-4 mb-4 mt-1 px-4">
        {allTeamChannelWithoutJoin.map((channelAllData: any, index: number) => {
          const { user: channelDetails } = channelAllData || {};
          const totalMembers = channelDetails?.member_count || 0;
          return (
            <div
              key={index}
              className="flex flex-col items-center bg-white border border-gray-200 rounded-lg p-2 shadow-sm hover:cursor-pointer min-w-32"
              onClick={() => {
                handleWhenSelectDataAndOpenLeftPanel(channelAllData);
              }}
            >
              <div className="w-11 h-11 bg-primary-250 rounded-full flex items-center justify-center mb-2">
                <ProfileImageComp
                  imageUrl={channelDetails?.image}
                  customClass="w-11 h-11"
                  is_opc={channelDetails?.memberships?.is_opc}
                />
              </div>
              <span className="text-center font-medium text-xs max-w-full text-primary-900 truncate">
                {channelDetails?.name}
              </span>
              <span className="text-[10px] text-center text-gray-500">
                {totalMembers} Members
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const renderNonMemberState = () => {
    return (
      <div className="text-center mt-10">
        <div className="text-primary-900 text-2xl font-semibold">
          {"Become a member to join groups"}
        </div>
        <div className="text-md text-primary-500">
          {"Only members can join groups"}
        </div>
        <div className="flex justify-center mt-4">
          <img
            src="/assets/logo/empty-chat.png"
            className="w-60"
            alt="placeholder"
          />
        </div>
        <div className="flex justify-center mx-4">
          <BecomeMemberButton />
        </div>
      </div>
    );
  };

  const renderGroupPage = () => {
    if (allTeamChannelWithoutJoin.length === 0) {
      return <></>;
    }
    return (
      <>
        <h2 className="text-lg font-semibold px-4">Suggested Groups</h2>
        {isOpcMember ? renderChannelList() : renderNonMemberState()}
      </>
    );
  };

  return (
    <div className="w-full bg-white h-full flex flex-col">
      {userData?.whatsapp_link ? (
        <a
          target="_blank"
          href={userData?.whatsapp_link}
          className="cursor-pointer flex items-center justify-between mb-4 p-2 border border-[#1fc191d9] rounded-xl mx-4 bg-[#34c759] bg-opacity-10 border-opacity-40"
        >
          <span className="text-primary-900 font-semibold">
            Join our Whatsapp Community
          </span>
          <img
            src="/assets/logo/whatsapp-icon.svg"
            className="w-8 h-8 ml-2"
            alt="whatsapp"
          />
        </a>
      ) : null}
      <div className="flex-none">{renderGroupPage()}</div>
      <div className="flex-1 min-h-0">
        <div className="h-full overflow-y-auto pb-4">
          {renderJoinedChannelList()}
        </div>
      </div>
    </div>
  );
};

export default GroupChat;
